export default __webpack_public_path__ + "static/media/ms_usericon.2ae5496c.svg";